<script>
  import { navigate } from 'svelte-routing';

  let email = '';
  let loading = false;
  let success = false;

  async function handleSubmit() {
    if (!email.trim()) {
      return;
    }

    loading = true;

    try {
      const response = await fetch('/api/password-reset/request', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email })
      });

      // Server always returns 200 for security
      if (response.ok) {
        success = true;
      }
    } catch (err) {
      console.error('Password reset request error:', err);
      // Still show success for security (don't reveal if request failed)
      success = true;
    } finally {
      loading = false;
    }
  }
</script>

<div class="min-h-screen flex items-center justify-center bg-gray-100">
  <div class="max-w-md w-full space-y-8 p-8 bg-white rounded-lg shadow-md">
    <div class="text-center">
      <img class="w-3/4 mx-auto h-24 w-auto rounded-md" src="/images/buildzilla-logo-lg.jpg" alt="Logo">
      <h2 class="mt-6 text-xl font-medium text-gray-900">Reset Your Password</h2>
    </div>

    {#if success}
      <!-- Success Message -->
      <div class="mt-8 space-y-6">
        <div class="p-4 bg-blue-50 border border-blue-200 rounded-md">
          <div class="flex">
            <div class="flex-shrink-0">
              <svg class="h-5 w-5 text-blue-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clip-rule="evenodd" />
              </svg>
            </div>
            <div class="ml-3">
              <h3 class="text-sm font-medium text-blue-800">Check Your Email</h3>
              <div class="mt-2 text-sm text-blue-700">
                <p>If an account exists with <strong>{email}</strong>, you will receive a password reset link shortly.</p>
                <p class="mt-2">Please check your inbox and follow the instructions in the email.</p>
                <p class="mt-2 text-xs text-blue-600">The link will expire in 24 hours.</p>
              </div>
            </div>
          </div>
        </div>

        <div class="text-center">
          <button
            on:click={() => navigate('/login')}
            class="text-sm text-[#313b55] hover:text-[rgb(158,158,158)] font-medium"
          >
            ← Back to Login
          </button>
        </div>
      </div>
    {:else}
      <!-- Request Form -->
      <form on:submit|preventDefault={handleSubmit} class="mt-8 space-y-6">
        <div>
          <p class="text-sm text-gray-600 mb-4">
            Enter your email address and we'll send you a link to reset your password.
          </p>
          <label for="email" class="block text-sm font-medium text-gray-700">Email Address</label>
          <input 
            id="email" 
            name="email" 
            type="email" 
            required 
            bind:value={email}
            on:input={(e) => email = e.target.value.toLowerCase()}
            class="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-[rgb(178,178,178)] focus:border-[rgb(178,178,178)]"
            placeholder="you@example.com"
            disabled={loading}
          >
        </div>

        <div>
          <button
            type="submit"
            disabled={!email.trim() || loading}
            class="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-[#313b55] hover:bg-[rgb(158,158,158)] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[rgb(178,178,178)] disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {#if loading}
              <span class="flex items-center">
                <svg class="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                  <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                  <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                </svg>
                Sending...
              </span>
            {:else}
              Send Reset Link
            {/if}
          </button>
        </div>

        <div class="text-center">
          <button
            type="button"
            on:click={() => navigate('/login')}
            class="text-sm text-[#313b55] hover:text-[rgb(158,158,158)] font-medium"
          >
            ← Back to Login
          </button>
        </div>

        <div class="text-center text-sm text-gray-500 mt-4">
          © 2025 All rights reserved
        </div>
      </form>
    {/if}
  </div>
</div>

